<template>
	<div>
		<div class="flex flex_column flex_between modal-content modal-content--in-group">
			<div class="flex flex_column w_60 margin_top">
				<form>
					<div class="form-group margin_top">
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.customerReference.text") }}</p>
						<div class="flex">
							<div class="flex_1">
								<md-field>
									<label>{{ $t('debtorManagement.addDebtor.customerReference.label') }}</label>
									<md-input
										v-model="form.customerReference"
									></md-input>
								</md-field>
							</div>
							<div class="flex_2">
							</div>
						</div>
					</div>

					<div class="form-group ">
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.applicableLaw.text") }}</p>
						<div class="flex">
							<div class="flex_1">
								<CountrySelect
									:labelText="$t('common.applicableLaw')"
									v-model="form.applicableLaw"
									:companyType=enumDef.companyType.DebtorCompany
									:required="true"
									data-vv-name="applicableLaw"
									v-validate="modelValidations.applicableLaw"
									:error="errors.first('applicableLaw')"
								></CountrySelect>
							</div>
							<div class="flex_1">
							</div>
						</div>
					</div>

					<div class="form-group">
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.historicalPaymentDays") }}</p>
						<div class="flex">
							<div class="flex_1">
								<md-field :class="[{ 'md-error': errors.has('historicalPaymentDays')}]">
									<label>{{ $t('common.days') }}</label>
									<MoneyAmountInput v-model="form.historicalPaymentDays"
													  data-vv-name="historicalPaymentDays"
													  v-validate="modelValidations.historicalPaymentDays"
													  :decimals="0"
													  required
									></MoneyAmountInput>
									<span v-if="errors.has('historicalPaymentDays')" class="validation-error">{{ errors.first('historicalPaymentDays') }}</span>
								</md-field>
							</div>
							<div class="flex_2">
							</div>
						</div>
					</div>

          <div class="form-group">
						<p class="text_left ">{{ "VAT rate (in %)" }}</p>
						<div class="flex">
							<md-field :class="'flex_1 margin_r' [{'md-error': errors.has('vatInPercent')}]">
								<label>{{ "in %" }}</label>
                <MoneyAmountInput v-model="form.vatInPercent" data-vv-name="vatInPercent"
													  v-validate="modelValidations.vatInPercent" required></MoneyAmountInput>
                <span v-if="errors.has('vatInPercent')" class="validation-error">{{ errors.first('vatInPercent') }}</span>
							</md-field>
							<div class="flex_1"></div>
						</div>
					</div>

					<div class="form-group">
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.relationshipSince") }}</p>
						<div class="flex">
							<md-radio
								v-model="form.longerThanOneYear"
								:value="true"
							>{{ $t("common.yes") }}
							</md-radio>
							<md-radio
								v-model="form.longerThanOneYear"
								:value="false"
							>{{ $t("common.no") }}
							</md-radio>
						</div>
					</div>

					<div class="form-group">
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.salesRevenue") }}</p>
						<div class="flex">
							<md-field class="flex_1 margin_r">
								<label>{{ $t('common.amount') }}</label>
								<MoneyAmountInput v-model="form.revenueLastTwelveMonths"
								></MoneyAmountInput>
							</md-field>
							<md-field class="flex_1">
								<label>{{ $t("common.currency") }}</label>
								<TbSelect v-model="form.revenueCurrency"
										  :search-allow="true"
										  :options="currencyOptions"
										  options-value-field="isoCode"
										  options-display-field="isoCode"
								/>
							</md-field>
							<div class="flex_1"></div>
						</div>
					</div>

					<div class="form-group">
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.shareOfSales") }}</p>
						<div class="flex">
							<md-field class="flex_1 margin_r">
								<label>{{ $t('common.from.inPercent') }}</label>
								<MoneyAmountInput v-model="form.shareOfSalesFrom"
								></MoneyAmountInput>
							</md-field>
							<md-field class="flex_1">
								<label>{{ $t('common.to.inPercent') }}</label>
								<MoneyAmountInput v-model="form.shareOfSalesTo"
								></MoneyAmountInput>
							</md-field>
							<div class="flex_1"></div>

						</div>
					</div>

					<div>
						<p class="text_left ">{{ $t("debtorManagement.addDebtor.offerDiscount") }}</p>
						<div class="flex">
							<md-radio
								v-model="form.offerDiscount"
								:value="true"
							>{{ $t("common.yes") }}
							</md-radio>
							<md-radio
								v-model="form.offerDiscount"
								:value="false"
							>{{ $t("common.no") }}
							</md-radio>
						</div>

						<div class="flex" v-show="form.offerDiscount === true">
							<md-field class="flex_1 margin_r">
								<label>{{ $t('debtorManagement.addDebtor.discountRate') }}</label>
								<MoneyAmountInput v-model="form.discountRate"
								></MoneyAmountInput>
							</md-field>
							<md-field class="flex_1">
								<label>{{ $t('debtorManagement.addDebtor.discountDays') }}</label>
								<md-input v-model="form.discountDays"></md-input>
							</md-field>
							<div class="flex_1"></div>
						</div>
					</div>
				</form>
			</div>
		</div>

		<div class="flex flex_end w_100 margin_top">
			<template v-if="isEditMode">
				<md-button :class="{ 'md-primary': isFormValid }" @click="confirmSubmitCreditManagement">
					{{ $t("common.save") }}
				</md-button>
			</template>
			<template v-else>
				<md-button :class="{ 'md-primary': isFormValid }" @click="next">
					{{ $t("common.continue") }}
				</md-button>
			</template>
		</div>
	</div>
</template>

<script>
import MoneyAmountInput from "src/components/templates/common/MoneyAmountInput";
import TbSelect from "src/components/templates/common/TbSelect";
import {debtorManagementApi} from "src/common/api/debtorManagementApi";
import {validateForm, validateRequiredFields} from "src/validation/validation";
import {enumDef} from "src/common/enumDefs";
import CountrySelect from "src/components/templates/select/CountrySelect";

export default {
	props: {
		relationId: { type: Number, default: null }
	},
	components: { MoneyAmountInput, TbSelect, CountrySelect },
	mounted() {
		this.loadCreditManagement();
	},
	data() {
		return {
			enumDef: enumDef,
			form: {
				applicableLaw: null,
				vatInPercent: null,
				longerThanOneYear: null,
				revenueLastTwelveMonths: null,
				revenueCurrency: null,
				shareOfSalesFrom: null,
				shareOfSalesTo: null,
				historicalPaymentDays: null,
				offerDiscount: null,
				discountRate: null,
				discountDays: null,
				customerReference: null,
			},
			modelValidations: {
				applicableLaw: {
					required: true
				},
				historicalPaymentDays: {
					required: true
				},
				vatInPercent: {
					required: true
				}
			},
			currencyOptions: [
				{ isoCode: "CHF" },
				{ isoCode: "EUR" },
				{ isoCode: "GBP" },
				{ isoCode: "USD" }
			]
		};
	},
	methods: {
		loadCreditManagement() {
			if (!this.relationId) {
				return;
			}
			debtorManagementApi.inspection.getCreditManagement(this.relationId)
			.then(res => {
				this.form = { ...res };
			}).catch(this.toast)
		},
		getData() {
			return this.form;
		},
		next() {
			validateForm(this, this.$validator).then(() => {
				this.$emit("next");
			}).catch(this.toast)
		},
		confirmSubmitCreditManagement() {
			validateForm(this, this.$validator).then(() => {
				let option = {
					title: this.$t("debtorManagement.editDebtor.confirm.title") ,
					msg: this.$t("debtorManagement.editDebtor.confirm.text"),
					confirmFun: this.submitCreditManagement
				};
				this.confirmMeg(option, true);
			}).catch(this.toast);
		},
		submitCreditManagement() {
			let credits = { ...this.form };
			let params = { id: this.relationId, credits: credits };
			debtorManagementApi.operation.saveDebtorCredit(params)
			.then(() => {
				this.$emit("relation-changed");
				this.toastSuccess();
			}).catch(this.toast)
		},
	},
	computed: {
		isEditMode() {
			return this.relationId;
		},
		isFormValid() {
			return validateRequiredFields(this.form, this.modelValidations);
		}
	}
};
</script>
<style lang="scss" scoped>
.md-radio {
	width: auto;
	margin: 10px 30px 0 10px;
	display: inline-flex;
	position: relative;
}

p {
	margin-bottom: 0;
}

.form-group {
	margin-bottom: 12px;
}

</style>